module.exports = __webpack_public_path__ + "static/media/tap_07_img06.21a7cbb3.png";